import { View, StyleSheet, Text, Image } from "@react-pdf/renderer";
import CaltexLubewatchLogo from "../../assets/images/logos/caltex-lubewatch-logo.png";

const styles = StyleSheet.create({
    headerWeb: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: 30,
        paddingTop: 10,
    },
    headerLogo: {
        height: 40,
        marginTop: -20,
    },
    headerH1Container: {
        padding: "5 45",
        backgroundColor: "#c6383a",
    },
    headerH1: {
        color: "white",
        fontSize: 16,
        fontWeight: 700,
        textTransform: "uppercase",
    },
    headerPageNumContainer: {
        flexDirection: "row",
        justifyContent: "flex-end",
        paddingTop: 5,
        paddingRight: 45,
    },
    headerPageNum: {
        fontSize: 12,
    },
    subHeaderWeb: {
        padding: "10 30",
    },
    subHeaderWebGrid: {
        flexDirection: "row",
        flexWrap: "wrap",
    },
    subHeaderWebTopic: {
        fontSize: 10,
        fontWeight: 600,
        color: "#00414f",
    },
    subHeaderWebTopic2: {
        fontSize: 10,
        fontWeight: 600,
        color: "#4d4e4d",
    },
    subHeaderTitle: {
        fontSize: 11,
        fontWeight: 600,
        color: "#00414f",
    },
    subHeaderOil: {
        fontSize: 11,
        fontWeight: 500,
        color: "#4d4e4d",
    },
});

const HeaderPDF = (props) => {
    const { data, convertNameToValue } = props;

    return (
        <View>
            <View style={styles.headerWeb}>
                <View>
                    <Image style={styles.headerLogo} src={CaltexLubewatchLogo} />
                </View>
                <View>
                    <View style={styles.headerH1Container}>
                        <Text style={styles.headerH1}>{props.pdfTitle}</Text>
                    </View>
                    <View style={styles.headerPageNumContainer}>
                        <Text style={styles.headerPageNum}>
                            หน้า {props.page}/{props.totalPage}
                        </Text>
                    </View>
                </View>
            </View>
            <View style={styles.subHeaderWeb}>
                <View style={styles.subHeaderWebGrid}>
                    <View
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                            gap: "20px",
                        }}
                    >
                        <View style={{ width: "auto" }}>
                            <Text style={styles.subHeaderWebTopic}>
                                Company Name <Text style={{ fontSize: "11px", fontWeight: "500" }}>(บริษัท)</Text> :
                            </Text>
                        </View>
                        <View style={{ width: "85%" }}>
                            <Text
                                style={{
                                    fontSize: "10px",
                                    fontWeight: "normal",
                                    whiteSpace: "pre-line",
                                    marginTop: "2px",
                                }}
                            >
                                {convertNameToValue(data, "company_name")}
                            </Text>
                        </View>
                    </View>
                    <View style={{ width: "50%" }}>
                        <View
                            style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "flex-start",
                                gap: "10px",
                            }}
                        >
                            <View style={{ width: "auto" }}>
                                <Text style={styles.subHeaderWebTopic}>
                                    Department <Text style={{ fontSize: "11px", fontWeight: "500" }}>(แผนก)</Text> :
                                </Text>
                            </View>
                            <View style={{ width: "50%" }}>
                                <Text
                                    style={{
                                        fontSize: "10px",
                                        fontWeight: "normal",
                                        whiteSpace: "pre-line",
                                        marginTop: "2px",
                                    }}
                                >{convertNameToValue(data, "department")}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={{ width: "50%" }}>
                        <View
                            style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "flex-start",
                                gap: "10px",
                            }}
                        >
                            <View style={{ width: "auto" }}>
                                <Text style={styles.subHeaderWebTopic}>
                                    Are Owner <Text style={{ fontSize: "11px", fontWeight: "500" }}>(ผู้ดูแล)</Text> :
                                </Text>
                            </View>
                            <View style={{ width: "50%" }}>
                                <Text
                                    style={{
                                        fontSize: "10px",
                                        fontWeight: "normal",
                                        whiteSpace: "pre-line",
                                        marginTop: "2px",
                                    }}
                                >{convertNameToValue(data, "coordinator")}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={{ width: "50%" }}>
                        <View
                            style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "flex-start",
                                gap: "10px",
                            }}
                        >
                            <View style={{ width: "200px" }}>
                                <Text style={styles.subHeaderWebTopic}>
                                    Testing Date{" "}
                                    <Text style={{ fontSize: "11px", fontWeight: "500" }}>(วันที่ทำการทดสอบ)</Text> :
                                </Text>
                            </View>
                            <View style={{ width: "50%" }}>
                                <Text
                                    style={{
                                        fontSize: "10px",
                                        fontWeight: "normal",
                                        whiteSpace: "pre-line",
                                        marginTop: "2px",
                                    }}
                                >{convertNameToValue(data, "testing_date")}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={{ width: "50%" }}>
                        <View
                            style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "flex-start",
                                gap: "10px",
                            }}
                        >
                            <View style={{ width: 150 }}>
                                <Text style={styles.subHeaderWebTopic}>
                                    Testing By{" "}
                                    <Text style={{ fontSize: "11px", fontWeight: "500" }}>(ผู้ทำการทดสอบ)</Text> :
                                </Text>
                            </View>
                            <View style={{ width: "50%" }}>
                                <Text
                                    style={{
                                        fontSize: "10px",
                                        fontWeight: "normal",
                                        whiteSpace: "pre-line",
                                        marginTop: "2px",
                                    }}
                                >{convertNameToValue(data, "tester_name")}</Text>
                            </View>
                        </View>
                    </View>
                    <View
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                            gap: "10px",
                            marginTop: "5px",
                        }}
                    >
                        <View>
                            <Text style={styles.subHeaderWebTopic2}>
                                Engine / Machine Name{" "}
                                <Text style={{ fontSize: "11px", fontWeight: "500" }}>(ชื่อเครื่องจักร/อุปกรณ์)</Text> :
                            </Text>
                        </View>
                        <View>
                            <Text
                                style={{
                                    fontSize: "10px",
                                    fontWeight: "normal",
                                    whiteSpace: "pre-line",
                                    marginTop: "2px",
                                }}
                            >{convertNameToValue(data, "machine_name")}</Text>
                        </View>
                    </View>
                    <View
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                            gap: "10px",
                        }}
                    >
                        <View>
                            <Text style={styles.subHeaderWebTopic2}>
                                Engine /  Machine ID or Plate number{" "}
                                <Text style={{ fontSize: "11px", fontWeight: "500" }}>(รหัสหรือเลขทะเบียนเครื่องจักร/อุปกรณ์)</Text> :
                            </Text>
                        </View>
                        <View>
                            <Text
                                style={{
                                    fontSize: "10px",
                                    fontWeight: "normal",
                                    whiteSpace: "pre-line",
                                    marginTop: "2px",
                                }}
                            >{convertNameToValue(data, "machine_id")}</Text>
                        </View>
                    </View>
                    <View
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                            gap: "10px",
                        }}
                    >
                        <View>
                            <Text style={styles.subHeaderWebTopic2}>
                                Engine / Machine Life{" "}
                                <Text style={{ fontSize: "11px", fontWeight: "500" }}>
                                    (อายุการใช้งานเครื่องจักร/อุปกรณ์)
                                </Text>{" "}
                                :
                            </Text>
                        </View>
                        <View>
                            <Text
                                style={{
                                    fontSize: "10px",
                                    fontWeight: "normal",
                                    whiteSpace: "pre-line",
                                    marginTop: "2px",
                                }}
                            >{convertNameToValue(data, "machine_life")}</Text>
                        </View>
                    </View>
                </View>
            </View>
            <View style={{ margin: "0 20px", padding: "5px 10px", backgroundColor: "#ebebea" }}>
                <Text style={styles.subHeaderTitle}>ข้อมูลน้ำมัน </Text>
                <View style={{ flexDirection: "row" }}>
                    <View style={{ width: "50%", flexDirection: "row", gap: "5px" }}>
                        <Text style={styles.subHeaderOil}>Oil Name (ชื่อน้ำมัน) : </Text>
                        <Text style={{ fontSize: "11px", color: "#333" }}>{convertNameToValue(data, "oil_name")}</Text>
                    </View>
                    <View style={{ width: "50%", flexDirection: "row", gap: "5px" }}>
                        <Text style={styles.subHeaderOil}>Oil Life (อายุการใช้น้ำมัน) : </Text>
                        <Text style={{ fontSize: "11px", color: "#333" }}>{convertNameToValue(data, "oil_life")}</Text>
                    </View>
                </View>
            </View>
        </View>
    );
};

export default HeaderPDF;
